import React, { useContext, useEffect } from 'react'
import { IonContent, IonPage, IonRouterLink, useIonViewWillEnter } from '@ionic/react'
import { Chip, CustomSpacer, FooterButtons, PagingContent, StyleIonHeader, TextStyle } from '../../../components'
import { StoresContext } from '../../../provider/StoreProvider'
import styled from 'styled-components'
import { DivideLineBold } from '../../../components/atoms/divide'
import { RouteComponentProps } from 'react-router'
import moment from 'moment-timezone'
import { observer } from 'mobx-react'

export const Qna: React.FC<RouteComponentProps> = observer(({ history }) => {
  const { commonStore, myStore } = useContext(StoresContext)
  const pagingStore = myStore.qnaPagingStore

  useIonViewWillEnter(() => {
    commonStore.setShowTab(false)
  })

  useEffect(() => {
    pagingStore.load(undefined, true)
  }, [])

  return (
    <IonPage>
      <StyleIonHeader type={'SUB'} title={'1:1 문의'} href={'/myPage'} />
      <IonContent>
        <QnaInfoWrap>
          <TextStyle type={'b_16'}>운영시간 안내</TextStyle>
          <div className="contents-sub-wrap">
            <CustomSpacer spacing="8px" />
            <TextStyle type={'r_13'} color={'primary_main'}>
              접수시간 24시간 접수 가능
            </TextStyle>
            <TextStyle type={'r_13'}>답변시간 (10:00 ~ 19:00)</TextStyle>
            <CustomSpacer spacing="8px" />
            <TextStyle type={'r_13'} color={'primary_light'}>
              답변시간 이후 접수건은 운영시간 내
            </TextStyle>
            <TextStyle type={'r_13'} color={'primary_light'}>
              순차적으로 답변해드립니다.
            </TextStyle>
          </div>
        </QnaInfoWrap>
        <DivideLineBold />
        <PagingContent pagingStore={pagingStore}>
          {pagingStore.list.map((d, i) => (
            <IonRouterLink key={i} routerLink={`/myPage/qna/detail/${d.id}`}>
              <AskContainer>
                <div className="date-wrap">
                  <TextStyle type={'r_11'} color={'primary_light'}>
                    {moment(new Date(d.createdDate)).format('YYYY/MM/DD')}
                  </TextStyle>
                  {d.status === 'WAIT_FOR_REPLY' ? (
                    <Chip type={'lightBlue'}>{'답변 대기' ?? '-'}</Chip>
                  ) : (
                    <Chip type={'black'}>{'답변 완료' ?? '-'}</Chip>
                  )}
                </div>
                <TextStyle type={'b_15'} color={'primary_dark'}>
                  {d.title ?? '-'}
                </TextStyle>
              </AskContainer>
            </IonRouterLink>
          ))}
        </PagingContent>
        <CustomSpacer spacing="50px" />
      </IonContent>
      <FooterButtons
        button={{
          color: 'dark',
          text: '문의하기',
          onClick: () => history.push('/myPage/qna/register'),
        }}
      />
    </IonPage>
  )
})

const QnaInfoWrap = styled.div`
  padding: 24px 20px;
  display: flex;
  flex-direction: column;
  font-size: 13px;
  .contents-sub-wrap {
    display: flex;
    flex-direction: column;
  }
`
const AskContainer = styled.div`
  padding: 24px 20px;
  display: flex;
  flex-direction: column;
  border-bottom: solid 1px var(--ion-color-gray100);
  .date-wrap {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 6px;
  }
  :hover {
    background-color: var(--ion-color-gray100);
  }
`
